// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload {
  margin-inline: 50px;
  margin-top: 40px;
}

.upload .document {
  margin-bottom: 80px;
}

.upload .document-border {
  margin-bottom: 80px;
  border-inline: 0.2px solid #e1dede;
}

.upload .upload-file {
  text-align: center;
  margin-bottom: 0;
  padding-inline: 20px;
}

.upload .upload-file h3 {
  font-size: 16px;
  color: #777777;
  font-weight: 600;
  margin-bottom: 0;
}

.upload .required {
  color: #fa5555;
  font-weight: 500;
}

.upload small {
  color: #fa5555;
  text-align: center;
}

.upload .upload-success {
  text-align: center;
  margin-bottom: 20px;
  color: green;
}

.upload .optional {
  color: #3483f4;
  font-weight: 500;
}

.upload .file-area {
  border: 1px dashed #3483f5;
  border-radius: 33px;
  padding: 30px 55px;
  color: #777777;
}

.upload .upload-icon {
  height: 50px;
  width: 50px;
  margin: 20px;
}

.upload .about-file {
  padding: 5px;
  display: flex;
  align-items: center;
  margin-top: 30px;
  border: 1px solid #e1dede;
  border-radius: 8px;
}

.about-file .file-image {
  background-color: #ddebff;
  padding: 5px;
  border-radius: 5px;
}

.about-file .file-image img {
  height: 20px;
  width: 20px;
}

.about-file input {
  background-color: transparent;
  border: none;
}

.about-file .file-name {
  margin-bottom: 0;
  padding-left: 10px;
  margin-right: auto;
  color: #000000;
}

.about-file .cancel-upload img {
  height: 20px;
  width: 20px;
  margin-right: 15px;
}

.click-upload-btn {
  color: blue;
}
`, "",{"version":3,"sources":["webpack://./src/components/DocumentItem.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".upload {\n  margin-inline: 50px;\n  margin-top: 40px;\n}\n\n.upload .document {\n  margin-bottom: 80px;\n}\n\n.upload .document-border {\n  margin-bottom: 80px;\n  border-inline: 0.2px solid #e1dede;\n}\n\n.upload .upload-file {\n  text-align: center;\n  margin-bottom: 0;\n  padding-inline: 20px;\n}\n\n.upload .upload-file h3 {\n  font-size: 16px;\n  color: #777777;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.upload .required {\n  color: #fa5555;\n  font-weight: 500;\n}\n\n.upload small {\n  color: #fa5555;\n  text-align: center;\n}\n\n.upload .upload-success {\n  text-align: center;\n  margin-bottom: 20px;\n  color: green;\n}\n\n.upload .optional {\n  color: #3483f4;\n  font-weight: 500;\n}\n\n.upload .file-area {\n  border: 1px dashed #3483f5;\n  border-radius: 33px;\n  padding: 30px 55px;\n  color: #777777;\n}\n\n.upload .upload-icon {\n  height: 50px;\n  width: 50px;\n  margin: 20px;\n}\n\n.upload .about-file {\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  margin-top: 30px;\n  border: 1px solid #e1dede;\n  border-radius: 8px;\n}\n\n.about-file .file-image {\n  background-color: #ddebff;\n  padding: 5px;\n  border-radius: 5px;\n}\n\n.about-file .file-image img {\n  height: 20px;\n  width: 20px;\n}\n\n.about-file input {\n  background-color: transparent;\n  border: none;\n}\n\n.about-file .file-name {\n  margin-bottom: 0;\n  padding-left: 10px;\n  margin-right: auto;\n  color: #000000;\n}\n\n.about-file .cancel-upload img {\n  height: 20px;\n  width: 20px;\n  margin-right: 15px;\n}\n\n.click-upload-btn {\n  color: blue;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
